import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

/**
 * Primary UI component for user interaction
 */
export const ResultCarousel = ({ data = [], classes = '', ...props }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const carouselSetting = {
    infinite: false,
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 2.25,
    slidesToScroll: 1,
  };

  const Wrapper = data.length > 2 && isMobile ? Slider : 'div'; 

  return (
    <div className={['card-carousel-container', 'w-full', classes && classes].join(' ')}>
      <Wrapper className="card-carousel sm:flex sm:flex-row sm:gap-4 sm:flex-wrap" {...(data.length > 2 && isMobile && carouselSetting)}>
        {data.map(item => (
          <div className="carousel-item pr-4 sm:pr-0 sm:grow">
            {item}
          </div>
        ))}
      </Wrapper>
    </div>
  );
};

ResultCarousel.propTypes = {
  /**
   * This is all our carousel array items
   */
  data: PropTypes.array,
  classes: PropTypes.string,
};
